module.exports = __webpack_public_path__ + "img/house-turret.5af854e8.svg";